export default {
    GET_ORDER_TICKET_AMOUNT: '/api/v1/order-ticket/amount',
    GET_ORDER_TICKET_DEAL: '/api/v1/order-ticket/deal',

    POST_ORDER_TICKET: '/api/v1/order-ticket',
    POST_ORDER_TICKET_USE: '/api/v1/order-ticket/use',
    POST_ORDER_TICKET_PAYMENT: '/api/v1/order-ticket-payment',
    POST_ORDER_TICKET_DIRECT: '/api/v1/order-ticket-direct',

    POST_ORDER_TICKET_BUSINESS: '/api/v1/order-ticket/business',
    
}